import styled from 'styled-components';

export default {
  Container: styled.div<{ isHidden: boolean; }>`
    opacity: ${props => props.isHidden ? 0 : 1};
  `,
};
